import { useGridFilters } from "@repo/baseCloud";
import { emptySegmentFilters, SegmentFilters } from "@repo/baseCloud/components";
import { DrugTestResultEnum } from "@repo/models";
import { DateTimePicker, DropDownList, FiltersV2 } from "@repo/ui";
import { useCallback } from "react";

import type { DrugTestsFilter } from "../../api/drugTestsApi";

import { DrugTestsGrid } from "./grid";

const initialFilters: DrugTestsFilter = {
	currentPage: 1,
	itemsPerPage: 25,
	startDate: null,
	endDate: null,
	brands: emptySegmentFilters.brandIds,
	channels: emptySegmentFilters.channelIds,
	marketers: emptySegmentFilters.marketerIds,
	states: emptySegmentFilters.stateIds,
	branches: emptySegmentFilters.branchIds,
	result: undefined,
};

const resultOptions = [
	{ label: "[ALL]", value: "ALL" },
	{ label: "Positive", value: DrugTestResultEnum.Positive.toString() },
	{ label: "Negative", value: DrugTestResultEnum.Negative.toString() },
];

export function DrugTestsPage() {
	const {
		filters,
		setFilters,
		appliedFilters: executedFilters,
		setAppliedFilters: setExecutedFilters,
		filtersProps,
	} = useGridFilters(initialFilters);

	const filterChanged = useCallback(
		(value: any, name: string) => {
			setFilters((prev) => ({ ...prev, [name]: value }));
		},
		[setFilters],
	);

	const segmentFiltersChanged = useCallback(
		(s) =>
			setFilters((prev) => ({
				...prev,
				brands: s.brandIds,
				channels: s.channelIds,
				marketers: s.marketerIds,
				states: s.stateIds,
				branches: s.branchIds,
			})),
		[setFilters],
	);

	return (
		<div className="w-full">
			<FiltersV2 {...filtersProps}>
				<DateTimePicker
					id="startDate"
					label="Conducted After:"
					dateOnly
					value={filters.startDate}
					changeHandler={filterChanged}
				/>
				<DateTimePicker
					id="endDate"
					label="Conducted Before:"
					dateOnly
					value={filters.endDate}
					changeHandler={filterChanged}
				/>
				<SegmentFilters onChange={segmentFiltersChanged} />
				<DropDownList
					id="result"
					label="Result:"
					values={resultOptions}
					value={filters.result ?? "ALL"}
					// "ALL" is a display option; the filter stores it as no value.
					changeHandler={(v) => filterChanged(v === "ALL" ? undefined : v, "result")}
					fullLength
				/>
			</FiltersV2>
			<DrugTestsGrid filters={executedFilters} setFilters={setExecutedFilters} />
		</div>
	);
}
